import classNames from "classnames";
import * as React from "react";
import { translate } from "../../locales/src/translate";
import { StepCategoryView } from "./StepCategoryView";

export interface IStepCategoryIndicatorProps {
  flowCategories: string[];
  allFlowCategories: string[];
  showAllAsFinished: boolean;
}

export const StepCategoryIndicator = (props: IStepCategoryIndicatorProps) => {
  const getNextCategory = (category) => {
    const nextIndex = props.allFlowCategories.indexOf(category) + 1;
    if (nextIndex == props.allFlowCategories.length)
      return translate("Klantondersteuning_Formulieren_FormulierVerstuurd");

    if (nextIndex > props.allFlowCategories.length) return undefined;
    return props.allFlowCategories[nextIndex];
  };
  const cssClassNames = classNames({
    stepcounter: true,
    "stepcounter--all-visited": props.showAllAsFinished
  });
  const stepcounterClasses = props.showAllAsFinished
    ? "stepcounter-module stepcounter-module--all-visited"
    : "stepcounter-module";

  return (
    <div className={stepcounterClasses}>
      {props.showAllAsFinished && (
        <div className="stepcounter-bar-context-mobile-finished">
          <span className="finished-icon" role="img" aria-hidden="true" />
          {translate("Klantondersteuning_Formulieren_FormulierVerstuurd")}
        </div>
      )}
      <div className={cssClassNames}>
        <div className="stepcounter-bar" />
        {props.allFlowCategories.map((category, index) => {
          return (
            <StepCategoryView
              key={`category${index}`}
              showAllAsFinished={props.showAllAsFinished}
              flowCategories={props.flowCategories}
              category={category}
              nextCategory={getNextCategory(category)}
              categoryIndex={props.allFlowCategories.indexOf(category)}
              allFlowCategories={props.allFlowCategories}
            />
          );
        })}
      </div>
    </div>
  );
};
